import { SystemMapDiagram as SystemMapDiagramCore } from '@diagram-kit/SystemMapDiagram';
import { useDiagramTheme } from './useDiagramTheme';

/** In-app docs: palette follows ThemeContext via shared diagram-kit palettes. */
export function SystemMapDiagram() {
  const p = useDiagramTheme();
  return <SystemMapDiagramCore palette={p} />;
}
